import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AccessibilityWidget from "./AccessibilityWidget";

export const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-white">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <AccessibilityWidget />
  </div>
);

export default Layout;
